import React from 'react';
import styled from 'styled-components';
import images from '_images';
import { _ } from '_locales';

const Container = styled.div`
  z-index: 1;
  display: flex;
  flex-direction: 'column';
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 70%;
  max-width: 400px;
  max-height: 85vh;
  background: #fff;
  border-radius: 10px;
`;

const CloseButton = styled.img`
  width: 20px;
  height: 20px;
  display: flex;
  display: flex;
  border-radius: 50%;
  margin-left: auto;
  margin-top: 5px;
  margin-right: 5px;
`;

const CongratulationsText = styled.h2`
  margin-top: 15px;
  font-size: 20px;
  padding: 0 2px;
`;

const CongratulationsContext = styled.h2`
  margin-bottom: 15px;
  font-size: 12px;
  text-align: center;
  padding: 0 2px;
`;

const CongratulationsImage = styled.img`
  height: 150px;
  margin-right: 3%;
  width: 150px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  margin-left: 5%;
  margin-top: 3%;
  margin-bottom: 5%;
  max-width: 90%;
  max-height: 90%;
`;

const PlayAgainButton = styled.button`
  font-size: 14px;
  margin-bottom: 5px;
  margin-top: 5px;
  width: 85%;
  max-width: 300px;
  height: 6vh;
  justify-content: center;
  align-items: center;
  background-color: #00008B;
  color: white;
  border: none;
  border-radius: 8px;
`;

const IamDoneButton = styled.button`
  font-size: 14px;
  margin-top: 5px;
  margin-bottom: 10px;
  width: 85%;
  max-width: 300px;
  height: 5vh;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  color: #00008B;
  border: none;
`;

const CongratulationsModal = ({
  clearedLevel,
  onClose,
  playAgain,
  iamDone
}) => (
  <Container>
    <ModalContent>
      <CloseButton src={images.recycleRight.close} onClick={onClose} />
      <CongratulationsText>
        {_('recycleRight.congratulations')}
      </CongratulationsText>
      <CongratulationsContext>
        {_('recycleRight.successfully_finished_level')}
        {' '}
        {clearedLevel}
        !
      </CongratulationsContext>
      <CongratulationsImage
        src={images.recycleRight.great_job}
      />
      <PlayAgainButton onClick={playAgain}>
        {_('recycleRight.play_again_button')}
      </PlayAgainButton>
      <IamDoneButton onClick={iamDone}>
        {_('recycleRight.i_am_done_button')}
      </IamDoneButton>
    </ModalContent>
  </Container>
);

export default CongratulationsModal;
